import React from 'react';
import PropTypes from 'prop-types';

const Play = ({ fill }) => (
  <svg width="100px" height="100px" viewBox="0 0 100 100" version="1.1">
    <defs>
      <path
        d="M45,0 C20.199,0 0,20.199 0,45 C0,69.801 20.199,90 45,90 C69.801,90 90,69.801 90,45 C90,20.199 69.801,0 45,0 Z M45,85 C22.898,85 5,67.102 5,45 C5,22.898 22.898,5 45,5 C67.102,5 85,22.898 85,45 C85,67.102 67.102,85 45,85 Z"
        id="path-1"
      />
      <filter
        x="-9.4%"
        y="-7.2%"
        width="118.9%"
        height="118.9%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="2.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0"
          type="matrix"
          in="shadowBlurOuter1"
        />
      </filter>
      <path
        d="M67.5,42.801 L35.602,24.399 C34.80122,24.00056 33.9028,24.00056 33.102,24.399 C32.30122,24.79744 31.8012,25.6998 31.8012,26.5982 L31.8012,63.3992 C31.8012,64.29764 32.3012,65.0984 33.102,65.5984 C33.50044,65.79762 33.90278,65.89918 34.4028,65.89918 C34.90282,65.89918 35.30124,65.79762 35.7036,65.5984 L67.6016,47.2004 C68.40238,46.80196 68.9024,45.8996 68.9024,45.0012 C68.89849,44.10276 68.30084,43.302 67.5001,42.802 L67.5,42.801 Z M36.898,59.102 L36.898,30.899 L61.3,45.001 L36.898,59.102 Z"
        id="path-3"
      />
      <filter
        x="-22.9%"
        y="-15.6%"
        width="145.8%"
        height="140.7%"
        filterUnits="objectBoundingBox"
        id="filter-4"
      >
        <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="2.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0"
          type="matrix"
          in="shadowBlurOuter1"
        />
      </filter>
    </defs>
    <g
      id="Profile-Jun-2020"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Gallery-tile-update_mobile"
        transform="translate(-273.000000, -306.000000)"
      >
        <g id="Group-6" transform="translate(278.000000, 309.000000)">
          <g id="Fill-1">
            <use
              fill="black"
              fillOpacity="1"
              filter="url(#filter-2)"
              xlinkHref="#path-1"
            />
            <use fill={fill} fillRule="evenodd" xlinkHref="#path-1" />
          </g>
          <g id="Fill-2">
            <use
              fill="black"
              fillOpacity="1"
              filter="url(#filter-4)"
              xlinkHref="#path-3"
            />
            <use fill={fill} fillRule="evenodd" xlinkHref="#path-3" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

Play.propTypes = {
  fill: PropTypes.string,
};

Play.defaultProps = {
  fill: 'white',
};

export default Play;
